import { AttrKeys } from '@sharedModule/constants/fields.constant';

export const COUNTRY_SETTINGS_ATTRIBUTES_CONSTANT = {
  sourceCountry: {
    type: 'select',
    key: 'source_country',
    label: 'Source Country',
  },
  upsertCountry: {
    srcCountryName: {
      type: 'select',
      key: 'srcCountryName',
      label: 'Country',
    },
    srcCurrencySupported: {
      type: 'text',
      key: 'srcCurrencySupported',
      label: 'Currency Supported',
    },
    srcMobileCode: {
      type: 'text',
      key: 'srcMobileCode',
      label: 'Mobile Code',
    },
    srcCountryCode: {
      type: 'text',
      key: 'srcCountryCode',
      label: 'Country Code',
    },
    srcCountryAlpha2Code: {
      type: 'text',
      key: 'srcCountryAlpha2Code',
      label: 'Country Alpha 2 Code',
    },
    destCountryName: {
      type: 'select',
      key: 'destCountryName',
      label: 'Country',
    },
    destCurrencySupported: {
      type: 'text',
      key: 'destCurrencySupported',
      label: 'Currency Supported',
    },
    destMobileCode: {
      type: 'text',
      key: 'destMobileCode',
      label: 'Mobile Code',
    },
    destCountryCode: {
      type: 'text',
      key: 'destCountryCode',
      label: 'Country Code',
    },
    destCountryAlpha2Code: {
      type: 'text',
      key: 'destCountryAlpha2Code',
      label: 'Country Alpha 2 Code',
    },
  },
  conversionRate: {
    search: {
      type: 'text',
      key: 'search',
      label: 'Search',
      placeholder: 'source/dest country',
    },
  },
  upsertConversionRate: {
    srcCountry: {
      type: 'select',
      key: 'src_country',
      label: 'Source Country',
    },
    destCountry: {
      type: 'select',
      key: 'dest_country',
      label: 'Destination Country',
    },
    sourceCurrency: {
      type: 'text',
      key: 'source_currency',
      label: 'Source Currency',
    },
    destinationCurrency: {
      type: 'text',
      key: 'destination_currency',
      label: 'Destination Currency',
    },
    transferType: {
      type: 'select',
      key: 'transfer_type_po',
      label: 'Transfer Type',
    },
    paymentType: {
      type: 'select',
      key: 'payment_type',
      label: 'Payment Type',
    },
    serviceLevel: {
      type: 'select',
      key: 'service_level',
      label: 'Service Level',
    },
    otherFee: {
      type: 'number',
      key: 'other_fee',
      label: 'Other Fee',
    },
    masterRate: {
      type: 'number',
      key: 'master_rate',
      label: 'Master Rate',
    },
    markupPercentage: {
      type: 'number',
      key: 'markup_percentage',
      label: 'Markup Percentage',
    },
    sellRate: {
      type: 'number',
      key: 'sell_rate',
      label: 'Sell Rate',
    },
    slabAmount: {
      type: 'number',
      key: 'slab_amount_upto',
      label: 'Slab Amount Upto',
    },
    fixedFee: {
      type: 'number',
      key: 'fixed_fee',
      label: 'Fixed Fee',
    },
    percentageFee: {
      type: 'number',
      key: 'percentage_fee',
      label: 'Percentage Fee',
    },
    useFixedFee: {
      type: 'checkbox',
      key: 'use_fixed_fee',
      label: 'Use Fixed Fee',
    },
  },
} as const;

export const COUNTRY_SETTINGS_MESSAGE_CONSTANT = {
  [COUNTRY_SETTINGS_ATTRIBUTES_CONSTANT.upsertConversionRate.sellRate
    .key as AttrKeys]: {
    pattern: 'maximum 6 digits allowed after decimal',
    confirmPasswordValidator: '',
  },
  [COUNTRY_SETTINGS_ATTRIBUTES_CONSTANT.upsertConversionRate.markupPercentage
    .key as AttrKeys]: {
    pattern: 'maximum 2 digits allowed after decimal',
    confirmPasswordValidator: '',
  },
};
